import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { renderIcon } from '../utils/iconRenderer';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  width?: string | number; // width prop 추가
  showCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  width, // width prop 추가
  showCloseButton = true
}) => {
  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // 모달이 열릴 때 body 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // 모바일 퍼스트 디자인: 모바일에서는 전체 화면, 데스크톱에서만 width 적용
  const isMobile = window.innerWidth <= 768;
  const modalStyle = !isMobile && width ? { width: typeof width === 'number' ? `${width}px` : width } : {};

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div
        className={`modal-container modal-${size}`}
        style={modalStyle}
      >
        {(title || showCloseButton) && (
          <div className="modal-header">
            {title && <h2 className="modal-title">{title}</h2>}
            {showCloseButton && (
              <button
                className="modal-close-button"
                onClick={onClose}
                aria-label="닫기"
              >
                {renderIcon(FaTimes)}
              </button>
            )}
          </div>
        )}

        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal; 